import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slotCard", "slotIdsContainer", "slotsContainer", "form"]

  removeSlot(event) {
    const slotId = event.currentTarget.dataset.slotId

    // Remove the hidden input for this slot
    const hiddenInput = this.slotIdsContainerTarget.querySelector(`input[data-slot-id="${slotId}"]`)
    if (hiddenInput) {
      hiddenInput.remove()
    }

    // Remove the card
    const card = this.slotCardTargets.find(c => c.dataset.slotId === slotId)
    if (card) {
      card.remove()
    }

    // If only one slot remains, hide all remove buttons
    const remainingCards = this.slotCardTargets
    if (remainingCards.length === 1) {
      const removeBtn = remainingCards[0].querySelector('[data-action="click->slot-removal#removeSlot"]')
      if (removeBtn) {
        removeBtn.classList.add("hidden")
      }
    }

    // If no slots remain, redirect back to calendar
    if (remainingCards.length === 0) {
      window.location.href = "/staff/calendar?filter=mine"
    }
  }
}
